export {default} from './AuthLayout';
export {default as Main} from './Main';
export {default as Header} from './Header';



// WEBPACK FOOTER //
// ./src/components/AuthLayout/index.ts